import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  searchBar: {
    height: 48,
    borderRadius: spacing(3),
    backgroundColor: grey[100],
    "@media print": {
      display: "none",
    },
  },
  root: {
    borderColor: grey[300],
  },
  focused: {
    backgroundColor: "#fff",
    "& $startAdornment": {
      fill: `${palette.primary.main} !important`,
      color: `${palette.primary.main} !important`,
    },
  },
  startAdornment: {
    color: palette.contrastIcon.main,
  },
  clearIcon: {
    color: palette.contrastIcon.main,
    width: 16,
    height: 16,
    cursor: "pointer",
  },
}));

export default styles;
